module.exports = __webpack_public_path__ + "img/file.44b4c08c.svg";